export default __webpack_public_path__ + "static/media/pair.749d71f3.svg";